// extracted by mini-css-extract-plugin
module.exports = {"inlineLoadingSkeleton":"InlineLoadingSkeleton_inlineLoadingSkeleton__13hyy"};